import {
  Container, Typography, Box, Stack,
} from '@mui/material';

import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import { selectEnterprise } from 'base/core/selectors';
import { useSelector } from 'react-redux';
import { getUserHubUrl } from 'utils/common-utils';

const userHubUrl = getUserHubUrl();

const Footer = () => {
  const enterpiseData = useSelector(selectEnterprise);

  return (
    <Box sx={
      {
        background: (t) => t.palette.primary.light!,
        py: { xs: 1, md: 2 },
      }
    }
    >
      <Container
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 1, md: 0 },
        }}
      >
        <Typography variant="body1" color="primary" sx={{ flex: 1 }} fontWeight="500" textAlign={{ xs: 'center', sm: 'left' }}>
          ©
          {' '}
          {new Date().getFullYear()}
          {' '}
          {enterpiseData.name}
          . All rights reserved
        </Typography>

        <Stack
          direction="row"
          spacing={4}
          alignItems="center"
          sx={{
            '> a:hover': {
              opacity: 0.6,
              transition: 'opacity 0.2s ease-in-out',
            },
          }}
        >
          {(enterpiseData.facebookUrl?.length) !== 0 && (
            <Typography
              component="a"
              display="flex"
              alignItems="center"
              href={`${enterpiseData.facebookUrl}`}
              target="_blank"
            >
              <FacebookIcon
                color="primary"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                sx={{
                  fontSize: { xs: 25 },
                }}
              />
            </Typography>
          )}
          {(enterpiseData.twitterUrl?.length) !== 0 && (
            <Typography
              component="a"
              display="flex"
              alignItems="center"
              href={`${enterpiseData.twitterUrl}`}
              target="_blank"
            >
              <TwitterIcon
                color="primary"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                sx={{
                  fontSize: { xs: 25 },
                }}
              />
            </Typography>
          )}
          {(enterpiseData.instagramUrl?.length) !== 0 && (
            <Typography
              component="a"
              display="flex"
              alignItems="center"
              href={`${enterpiseData.instagramUrl}`}
              target="_blank"
            >
              <InstagramIcon
                color="primary"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                sx={{
                  fontSize: { xs: 25 },
                }}
              />
            </Typography>
          )}
        </Stack>

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            '> a': {
              cursor: 'pointer',
              px: { xs: 4, sm: 6 },
              '&:first-of-type': {
                pl: 0,
              },
              '&:last-of-type': {
                pr: 0,
              },
              '&:not(:last-of-type)': {
                borderRight: (t) => (`1px solid ${t.palette.primary.main}`),
              },
            },
          }}
        >
          <Typography
            color="primary"
            sx={{
              textDecoration: 'none',
            }}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            component="a"
            href={userHubUrl}
            target="_blank"
            fontWeight="500"
          >
            User login
          </Typography>
          <Box
            component="a"
            href={
              enterpiseData?.termsAndConditionsPage?.link && enterpiseData.termsAndConditionsPage.link !== ''
                ? enterpiseData.termsAndConditionsPage.link : 'https://www.poweredbyslocoach.com/termsandconditions'
            }
            target="_blank"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            color="primary"
            sx={{
              textDecoration: 'none',
            }}
          >
            <Typography
              sx={{
                textDecoration: 'none',
              }}
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              color="primary"
              fontWeight="500"
              display={{ xs: 'none', sm: 'block' }}
            >
              Terms & conditions
            </Typography>
            <Typography
              sx={{
                textDecoration: 'none',
              }}
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              color="primary"
              fontWeight="500"
              display={{ sm: 'none' }}
            >
              T & C
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
